import { cn } from "@/lib/utils";

const STYLES = {
  "Draft": "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
  "In Review": "bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800/50",
  "Waiting for Vijayalakshmi": "bg-emerald-50 text-emerald-800 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800/50",
  "Waiting for Vishwa": "bg-teal-50 text-teal-800 border-teal-300 dark:bg-teal-950/60 dark:text-teal-300 dark:border-teal-800/50",
  "Returned for Changes": "bg-orange-50 text-orange-800 border-orange-200 dark:bg-orange-950/60 dark:text-orange-300 dark:border-orange-800/50",
  "Approved": "bg-green-50 text-green-800 border-green-300 dark:bg-green-950/60 dark:text-green-300 dark:border-green-800/50",
  "Ready to Publish": "bg-blue-50 text-blue-800 border-blue-200 dark:bg-blue-950/60 dark:text-blue-300 dark:border-blue-800/50",
  "Published": "bg-emerald-100 text-emerald-900 border-emerald-400 font-semibold dark:bg-emerald-900/80 dark:text-emerald-100 dark:border-emerald-700",
  "Overdue": "bg-red-50 text-red-800 border-red-200 dark:bg-red-950/60 dark:text-red-300 dark:border-red-800/50",
  "Active": "bg-green-50 text-green-800 border-green-300 dark:bg-green-950/60 dark:text-green-300 dark:border-green-800/50",
  "Inactive": "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700",
  "Not Connected": "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700",
  "Connected": "bg-green-50 text-green-800 border-green-300 dark:bg-green-950/60 dark:text-green-300 dark:border-green-800/50",
};

export function StatusBadge({ status, className }) {
  return (
    <span
      data-testid={`status-${status?.toLowerCase().replace(/\s+/g, "-")}`}
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium",
        STYLES[status] || STYLES["Draft"],
        className
      )}
    >
      {status}
    </span>
  );
}

export default StatusBadge;
